export default __webpack_public_path__ + "static/media/success.270473e0.svg";